import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { Button, Form } from 'react-bootstrap'

import { logInUser } from '../reducers/loginReducer'

class LoginForm extends Component {
  state = {
    username: '',
    password: '',
  }

  handleChange = (e) => this.setState({ [e.target.name]: e.target.value })

  handleLogin = () => this.props.logInUser(this.state)

  handleEnterPress = (e) => {
    if (e.key === 'Enter') {
      this.handleLogin()
    }
  }

  render() {
    return (
      <div id="LoginForm">

        {this.props.errorMessage ?
          <h5>
            {this.props.errorMessage}
          </h5>
          :
          null
        }

        <Form onKeyDown={this.handleEnterPress}>
          <Form.Group>
            <Form.Label>
              Username
            </Form.Label>
            <Form.Control
              type="text"
              placeholder="Enter username"
              name='username'
              onChange={this.handleChange}
            />
          </Form.Group>

          <Form.Group >
            <Form.Label>
              Password
            </Form.Label>
            <Form.Control
              type="password"
              placeholder="Password"
              name='password'
              onChange={this.handleChange}
            />
          </Form.Group>

          <Button
            variant="primary"
            onClick={this.handleLogin}
          >
            Login
          </Button>
        </Form>

        <br/>

        <p>
          <Link to='reset-password'>
            Forgot password?
          </Link>
        </p>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    errorMessage: state.loginReducer.errorMessage,
  }
}


export default connect(mapStateToProps, { logInUser })(LoginForm)
